import SearchForm from 'emerald-ui/lib/SearchForm';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: SearchForm, componentName: 'SearchForm' }], 'SearchForm'),
  description: 'A form containing a single input field designed for searching. It goes mainly above a table.',
  codeSamples: [
    {
      title: 'Default',
      scope: { SearchForm },
      code: `<SearchForm
  inputId="query"
  onSubmit={e => e.preventDefault()}
  onChange={e => {
    console.log(e.target.value);
  }}
/>`,
    },
  ],
};
